<template>
  <div class="factory-card-edit">
    <div class="content-wrapper">
      
      <label for="logo" class="logo-wrapper" @click="onClickInputFile">
        <img v-if="profile.logo" :src="profile.logo" class="logo">
        <img v-else-if="!profile.logo && logo" :src="logo" class="logo" ref="logo" alt="なし">
        <img v-else src="../assets/images/factory_default.png" class="logo" ref="logo" alt="なし">
        <input type="file" id="logo" ref="logoInput" name="logo" accept="image/png, image/jpeg" @change="onLogoSelected">
      </label>

      <div class="input-wrapper">
        <label for="name">お名前</label>
        <input name="name" type="text" v-model="facName">
      </div>
      <div class="input-wrapper">
        <label for="postal">郵便番号</label>
        <input name="postal" type="text" v-model="facPostal">
      </div>
      <div class="input-wrapper">
        <label for="location">所在地</label>
        <input name="location" type="text" v-model="facLocation">
      </div>
      <div class="input-wrapper">
        <label for="googleMap">MAP URL</label>
        <input name="googleMap" type="text" v-model="facGoogleMapUrl">
      </div>
      <div class="input-wrapper">
        <label for="website">URL</label>
        <input name="webste" type="text" v-model="facWebsite">
      </div>
      <div class="textarea-wrapper">
        <label for="intro">自己紹介</label>
        <textarea name="intro" id="" cols="30" rows="10" maxlength="160" v-model="facDescription"></textarea>
      </div>
      <div class="file-wrapper">
        <p>拠点写真</p>
        <div class="file-row">
          <div class="picture-wrapper">
            <img src="../assets/images/add_photo.png" class="pointer" @click="$refs.photoInput.click()">
            <input type="file" id="photo" ref="photoInput" name="photo" accept="image/png, image/jpeg" @change="onPhotoSelected">
          </div>
          
          <template v-if="!profile.pictures">
            <div v-for="(pic, index) in pictures" class="picture-wrapper">
              <img src="../assets/images/plus_circle.png" class="delete-img pointer" @click="onDeletePicture(index)">
              <img :src="pic">
            </div>
          </template>
          <template v-else>
            <div v-for="(pic, index) in profile.pictures" class="picture-wrapper">
              <img src="../assets/images/plus_circle.png" class="delete-img pointer" @click="onDeletePicture(index)">
              <img :src="pic">
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="button-section">
      <button @click.prevent.stop="$emit('cancelCardEdit')">キャンセル</button>
      <button class="green-button" @click.prevent.stop="$emit('saveCardEdit', profile)">保存する</button>
    </div>
  </div>
</template>

<script>

export default  {
  name: "FactoryCard",
  props: {
    name: '',
    pictures: Array,
    logo: '',
    location: '',
    website: '',
    service: '',
    description: '',
    postal: '',
    googleMapUrl: '',
  },
  data () {
    return {
      profile: {
        name: null,
        pictures: null,
        logo: null,
        location: null,
        website: null,
        service: null,
        description: null,
        postal: null,
        googleMapUrl: null,
      },
    }
  },

  mounted () {
    // profile_name = this.name;
    // console.log('name: ', this.profile.name);
    // console.log('propName: ', this.name);
    // this.data.photos = this.photos;
    // this.data.logo = this.logo;
    // this.data.location = this.location;
    // this.data.website = this.website;
    // this.data.service = this.service;
    // this.data.introduction = this.introduction;
  },

  computed: {
    facName: {
      get () {
        this.profile.name = this.name;
        return this.name;
      },
      set (newVal) {
        this.profile.name = newVal;
      }
    },
    facPostal: {
      get () {
        this.profile.postal = this.postal;
        return this.postal;
      },
      set (newVal) {
        this.profile.postal = newVal;
      }
    },
    facGoogleMapUrl: {
      get () {
        this.profile.googleMapUrl = this.googleMapUrl;
        return this.googleMapUrl;
      },
      set (newVal) {
        this.profile.googleMapUrl = newVal;
      }
    },
    facLocation: {
      get () {
        this.profile.location = this.location;
        return this.location;
      },
      set (newVal) {
        this.profile.location = newVal;
      }
    },
    facWebsite: {
      get () {
        this.profile.website = this.website;
        return this.website;
      },
      set (newVal) {
        this.profile.website = newVal;
      }
    },
    facDescription: {
      get () {
        this.profile.description = this.description;
        return this.description;
      },
      set (newVal) {
        this.profile.description = newVal;
      }
    },
  },

  methods: {
    onClickInputFile () {
      this.$refs.logoInput.click();
    },
    onLogoSelected (event) {
      const file = event.target.files[0];
      if (file && file.type.match('image.*')) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.profile.logo = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    onPhotoSelected (event) {
      const file = event.target.files[0];
      if (file && file.type.match('image.*')) {
        const reader = new FileReader();
        reader.onload = (e) => {
          // this.profile.logo = e.target.result;
          if (!this.profile.pictures) {
            this.profile.pictures = this.pictures;
            this.profile.pictures.splice(0, 0, e.target.result);
          } else {
            this.profile.pictures.splice(0, 0, e.target.result);
          }
        };
        reader.readAsDataURL(file);
      }
    },
    onDeletePicture (index) {
      if (!this.profile.pictures) {
        this.profile.pictures = this.pictures;
        this.profile.pictures.splice(index, 1);
      } else {
        this.profile.pictures.splice(index, 1);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .factory-card-edit {
    position: relative;
    width: 330px;
    color: #000;
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
    .img-wrapper {
      width: 100%;

      img {
        width: 100%;
      }
    }

    .content-wrapper {
      padding: 1rem;

      .logo-wrapper {
        // margin-bottom: 1rem;
        .logo {
          margin-bottom: 1rem;
          width: 50px;
          height: 50px;
          border-radius: 99em;
        }

        #logo {
          display: none;
        }

        img {
          cursor: pointer;
        }
      }

      .input-wrapper {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 1rem;

        label {

        }

        input {
          background-color: #EEEEEE;
          width: 220px;
          height: 2rem;
          border-radius: 10px;
          padding: 5px 10px;
        }
      }

      .textarea-wrapper {
        width: 100%;
        display: flex;
        align-items: start;
        justify-content: space-between;
        margin-bottom: 1rem;

        textarea {
          width: 220px;
          height: 100px;
          background-color: #EEEEEE;
          border-radius: 10px;
          padding: 5px 10px;
        }
      }

      .file-wrapper {
        width: 100%;
        display: flex;
        align-items: start;
        justify-content: space-between;
        margin-bottom: 1rem;

        p {

        }

        .file-row {
          width: 220px;
          display: flex;
          overflow-x: scroll;
          height: 90px;
          transform: translateY(-10px);
          .picture-wrapper {
            position: relative;

            img {
              width: 100%;
              height: 100%;
              width: 80px;
              height: 80px;
              margin-right: .5rem;
              border-radius: 10px;
              transform: translateY(10px);
            }

            #photo {
              display: none;
            }

            .delete-img {
              position: absolute;
              width: 30px;
              height: 30px;
              margin: 0;
              border-radius: 99em;
              right: 0;
              top: 0;
              transform: translateX(3px) translateY(-3px);
              z-index: 99;
            }
          }

          .pointer {
            cursor: pointer;
          }

        }
      }
    }

    .button-section {
      width: 100%;
      padding: 1rem;
      display: flex;
      justify-content: end;
      button {
        width: fit-content;
        height: 45px;
        padding: 0 15px;
        font-size: 14px;
        line-height: 1;
        background-color: #eeeeee;
        border-radius: 99em;
        margin-left: 1rem;
      }
      .green-button {
        background-color: #1bffc6;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/FactoryCardEdit.vue